import React from "react";

const IngresoEvaluaciones = () => {
    return (
        <div className="container mt-4">
            <div className="card">
                <div className="card-body">
                    <h1 className="mb-4">Ingreso de Evaluaciones</h1>

                    {/* Selección de candidata */}
                    <div className="mb-4">
                        <label htmlFor="buscarCandidata" className="form-label">
                            Seleccionar Candidata
                        </label>
                        <input
                            type="text"
                            id="buscarCandidata"
                            className="form-control"
                            placeholder="Búsqueda de Candidata"
                        />
                    </div>

                    {/* Información de candidata seleccionada */}
                    <div className="border p-4 mb-4">
                        <h5 className="mb-3">Mostrar Información de Candidata Seleccionada</h5>
                        <div className="row g-3">
                            <div className="col-md-6">
                                <label htmlFor="rut" className="form-label">Rut o Pasaporte</label>
                                <input type="text" id="rut" className="form-control" />
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="nombre" className="form-label">Nombre</label>
                                <input type="text" id="nombre" className="form-control" />
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="primerApellido" className="form-label">Primer Apellido</label>
                                <input type="text" id="primerApellido" className="form-control" />
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="segundoApellido" className="form-label">Segundo Apellido</label>
                                <input type="text" id="segundoApellido" className="form-control" />
                            </div>
                            <div className="col-md-12">
                                <label htmlFor="direccion" className="form-label">Dirección</label>
                                <input type="text" id="direccion" className="form-control" />
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="comuna" className="form-label">Comuna</label>
                                <input type="text" id="comuna" className="form-control" />
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="email" className="form-label">Email</label>
                                <input type="email" id="email" className="form-control" />
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="telefonoFijo" className="form-label">Teléfono Fijo</label>
                                <input type="text" id="telefonoFijo" className="form-control" />
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="numeroCelular" className="form-label">Número de Celular</label>
                                <input type="text" id="numeroCelular" className="form-control" />
                            </div>
                        </div>
                    </div>

                    {/* Ingresar Evaluaciones */}
                    <div className="border p-4">
                        <h5 className="mb-3">Ingresar Evaluaciones</h5>
                        <div className="row g-3">
                            <div className="col-md-6">
                                <label htmlFor="evaluacionTecnico" className="form-label">
                                    Evaluación Técnico
                                </label>
                                <input type="text" id="evaluacionTecnico" className="form-control" placeholder="Ingresar Puntaje del Test" />
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="presentacionPersonal" className="form-label">
                                    Evaluación - Presentación Personal
                                </label>
                                <textarea id="presentacionPersonal" className="form-control" placeholder="Ingresar Texto Libre"></textarea>
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="evaluacionDicion" className="form-label">
                                    Evaluación - Dicción
                                </label>
                                <select id="evaluacionDicion" className="form-select">
                                    <option value="Insuficiente">Insuficiente</option>
                                    <option value="Suficiente">Suficiente</option>
                                    <option value="Sobre lo esperado">Sobre lo esperado</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    {/* Botón */}
                    <div className="mt-4 text-center">
                        <button className="btn btn-primary">Agendar</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default IngresoEvaluaciones;
